import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useProfile } from '../context/ProfileContext';

const Layout = () => {
  const { loading, data } = useProfile();

  if (loading || !data) {
    return (
      <div className="flex min-h-screen bg-gray-50 font-sans items-center justify-center">
        <div className="text-xl text-gray-500 font-medium animate-pulse">Loading Application...</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      <Sidebar />
      <div className="flex-1 ml-64 flex flex-col">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;